import "@mantine/core/styles.css"
import "@mantine/notifications/styles.css"
import "./styles/global.css"
import { createTheme, MantineProvider } from "@mantine/core"
import { Notifications } from "@mantine/notifications"
import { resolvePage } from "./lib/routes"
import { AccountsPage } from "./pages/app/accounts-page"
import { AdminUsersPage } from "./pages/app/admin-users-page"
import { DashboardPage } from "./pages/app/dashboard-page"
import { AppDocsPage } from "./pages/app/docs/app-docs-page"
import { SettingsPage } from "./pages/app/settings-page"
import { SiteDetailPage } from "./pages/app/site-detail-page"
import { SitesPage } from "./pages/app/sites-page"
import { DocsPage } from "./pages/docs-page"
import { HomePage } from "./pages/home-page"
import { LaunchPage, LaunchSuccessPage } from "./pages/launch-page"
import { LoginPage } from "./pages/login-page"
import { NotFoundPage } from "./pages/not-found-page"
import { PricingPage } from "./pages/pricing-page"
import { PrivacyPage } from "./pages/privacy-page"
import { TermsPage } from "./pages/terms-page"

const theme = createTheme({
  fontFamily:
    'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  headings: {
    fontFamily:
      'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  },
  primaryColor: "dark",
  defaultRadius: "sm",
})

export function App({ pathname, search }: { pathname: string; search: string }) {
  return (
    <MantineProvider theme={theme}>
      <Notifications position="top-right" />
      <AppRoutes pathname={pathname} search={search} />
    </MantineProvider>
  )
}

function AppRoutes({ pathname, search }: { pathname: string; search: string }) {
  const page = resolvePage(pathname)

  switch (page) {
    case "home":
      return <HomePage />
    case "docs":
      return <DocsPage />
    case "docs-topic":
      return <DocsPage topic={docsTopicFromPathname(pathname)} />
    case "pricing":
      return <PricingPage />
    case "privacy":
      return <PrivacyPage />
    case "terms":
      return <TermsPage />
    case "login":
      return <LoginPage />
    case "launch":
      return <LaunchPage search={search} />
    case "launch-success":
      return <LaunchSuccessPage search={search} />
    case "dashboard":
      return <DashboardPage />
    case "app-docs":
      return <AppDocsPage />
    case "settings":
      return <SettingsPage />
    case "admin-users":
      return <AdminUsersPage />
    case "sites":
      return <SitesPage />
    case "site-detail":
      return <SiteDetailPage siteId={siteIdFromPathname(pathname)} search={search} />
    case "accounts":
      return <AccountsPage />
    default:
      return <NotFoundPage />
  }
}

function siteIdFromPathname(pathname: string): string {
  return decodeURIComponent(pathname.replace(/\/+$/, "").split("/").pop() ?? "")
}

function docsTopicFromPathname(pathname: string): string {
  return decodeURIComponent(pathname.replace(/\/+$/, "").split("/").pop() ?? "")
}
